module.exports = __webpack_public_path__ + "img/code_tg.e51ef7db.png";